<template>
    <v-app pb-3>
        <v-content>
            <v-container style="max-width: 1200px; padding-top: 100px">
                <a class="pt-4" href="/dashboard">Личный кабинет</a>
                <br>
                <a class="pb-4" :href="'/osago/new/' + uuid">Назад</a>
                <v-layout pt-4 pb-5 row wrap>
                    <v-flex xs12>
                        <h1 class="py-4" v-html="title"></h1>
                    </v-flex>
                </v-layout>
            </v-container>

            <v-container>
                <v-layout align-center justify-start class="result">
                    <v-flex v-if="companyLogo" xs12 sm6 md4>
                        <img :src="companyLogo" class="logo hidden-xs-only"/>
                        <img :src="companyLogo" class="logo-sm hidden-sm-and-up"/>
                    </v-flex>
                </v-layout>
                <v-layout align-center justify-start class="result">
                    <v-flex v-if="companyLogo" xs12 sm6 md4>
                        <p>Страховая премия {{premium}} руб.</p>
                    </v-flex>
                </v-layout>
                <v-layout row wrap>
                    <v-flex xs12 sm6 md8 px-2>
                        <v-text-field
                            :readonly="true"
                            :value="link"
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm3 md2 pt-3 px-2>
                        <v-btn class="text-center submit-button"
                           v-clipboard="link"
                           onclick="PNotify.success('Ссылка скопирована в буфер обмена')"
                        >Копировать
                        </v-btn>
                    </v-flex>
                    <v-flex xs12 sm3 md2 pt-3 px-2>
                        <v-btn class="text-center submit-button"
                               @click="redirect"
                        >Оплатить
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-container>

            <v-container>
                <v-form ref="form" mt-4 pt-4>
                    <v-layout row>
                        <h3>Отправить ссылку на оплату</h3>
                    </v-layout>
                    <v-layout row>
                        <v-checkbox
                            label="на e-mail"
                            v-model="emailChecked"
                        />
                    </v-layout>
                    <v-layout row>
                        <v-flex xs12 sm6 md4>
                            <v-text-field
                                v-if="emailChecked"
                                v-model="email"
                                :rules="emailRules"
                                label="E-mail"
                                validate-on-blur
                            />
                            <v-text-field
                                v-if="!emailChecked"
                                :value="email"
                                label="E-mail"
                                :disabled="true"
                            />
                        </v-flex>
                    </v-layout>
                    <v-layout row>
                        <v-checkbox
                            label="на телефон"
                            v-model="phoneChecked"
                        />
                    </v-layout>
                    <v-layout row>
                        <v-flex xs12 sm6 md4>
                            <v-text-field
                                v-if="phoneChecked"
                                v-model="maskedPhone"
                                :rules="phoneRules"
                                :disabled="!phoneChecked"
                                v-mask="'+7 ### ### ## ##'"
                                label="Телефон"
                                validate-on-blur
                            />
                            <v-text-field
                                v-if="!phoneChecked"
                                :value="maskedPhone"
                                v-mask="'+7 ### ### ## ##'"
                                label="Телефон"
                                :disabled="true"
                            />
                        </v-flex>
                    </v-layout>
                    <v-layout row>
                        <v-flex xs12 sm6 md4>
                            <v-btn
                                class="text-center submit-button"
                                :disabled="(!phoneChecked && !emailChecked) || linkSentCount >= 3"
                                :loading="linkSending"
                                @click="sendLink"
                            >Отправить
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-form>
            </v-container>
        </v-content>
    </v-app>
</template>

<script>
export default {
    name: "ManageLink",
    props: {
        link: {
            default: null
        },
        hashId: {
            default: null
        },
        companyLogo: {
            default: null
        },
        premium: {
            default: null
        },
        email: {
            default: null
        },
        phone: {
            default: null
        },
        uuid: {
            default: null
        },
        type: {
            default: 'OSAGO'
        }
    },
    data: () => ({
        phoneChecked: false,
        emailChecked: false,
        maskedPhone: null,
        linkSending: false,
        linkSentCount: 0,
        title: 'Ссылка на оплату',
        emailRules: [
            v => !this.emailChecked || !!v || 'Обязательное поле',
            v => !(/[а-яё\s]/i.test(v)) || 'E-mail не должен содержать кириллицу и пробелы',
            v => !(/[_.-]{2}/.test(v)) || 'Email не должен содержать идущие друг за другом знак подчеркивания, точку и минус',
            v => /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,24}\b/.test(v) || 'Неверный формат',
        ],
        phoneRules: [
            v => !this.phoneChecked || !!v || 'Обязательное поле',
            v => /^\+7 \d{3} \d{3} \d{2} \d{2}$/.test(v) || 'Неверный формат'
        ],
    }),
    created() {
        this.type = 'CROSS';
        this.maskedPhone = '+' + this.phone;
        if (this.type === 'OSAGO') {
            this.title = 'Ссылка на оплату ОСАГО'
        } else if (this.type === 'CROSS') {
            this.title += ' Кросс-полиса'
        }
    },
    methods: {
        // перенаправить пользователя по ссылке на оплату
        redirect() {
            window.open(this.link);
        },
        sendLink() {
            if (!this.$refs.form.validate()) {
                PNotify.error('Проверьте правильность выделенных полей');
                return;
            }
            if (!this.emailChecked && !this.phoneChecked) {
                PNotify.info('Невозможно отправить ссылку');
                return;
            }
            if (this.linkSentCount >= 3) {
                PNotify.info('Исчерпан лимит отправки ссылок');
                return;
            }
            this.linkSending = true;
            const data = {
                'sendEmail': this.emailChecked,
                'email': this.email,
                'sendSms': this.phoneChecked,
                'phone': this.unmaskPhone(this.maskedPhone),
                'type': this.type
            };
            axios.post('/send-link/' + this.hashId, data)
            .then(response => {
                const success = response.data && response.data.status && response.data.status === 'success';
                let sent = false;
                if (success) {
                    sent = response.data.emailSent || response.data.smsSent;
                    if (sent) {
                        this.linkSentCount++;
                        PNotify.success('Ссылка была отправлена');
                    }
                }
                if (!success || !sent) {
                    PNotify.info('Не удалось отправить уведомление');
                    console.log(response);
                }
            })
            .catch(error => {
                console.log(error);
                PNotify.error('Не удалось отправить уведомление');
            })
            .finally(() => { this.linkSending = false; });
        },
        unmaskPhone(phone) {
            return phone ? phone.match(/[0-9]+/g, '').join('') : phone;
        }
    }
}
</script>

<style scoped>
/deep/ h1 {
    font-size: 65px;
    font-family: 'SFPro';
    line-height: 1.1;
    font-weight: 700;
    color: #000000;
}

/deep/ h2, h3 {
    font-family: 'SFProBold';
}

/deep/ h2 {
    font-size: 28px;
}

/deep/ h3 {
    font-size: 20px;
}

.submit-button {
    color: #ffffff !important;
    line-height: 1.45 !important;
    font-weight: 700 !important;
    font-size: 18px !important;
    text-transform: none !important;
    box-shadow: none !important;

    height: 56px;
    width: 100%;
    background-color: #00ba57 !important;
    text-align: center;
    vertical-align: middle;
    padding: 0 !important;
    margin: 0;

    border-width: 1px;
    border-radius: 100px;
    border-color: transparent;
    border-style: solid;
}

.submit-button >>> .v-btn__content {
    white-space: pre-wrap;
    margin: 16px 0 0;
    line-height: 1.1;
}

.logo {
    max-width: 100%;
    width: 200px;
}

.logo-sm {
    max-width: 200px;
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// resources/js/components/b2b/ManageLink.vue